import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { PORTFOLIO } from "../lib/content";
import CaseStudyDialog from "./CaseStudyDialog";

export const Portfolio = () => {
  const [selected, setSelected] = useState(null);

  const openCase = (c) => setSelected(c);

  return (
    <section
      id="portafolio"
      data-testid="portfolio-section"
      className="bg-slate-50 py-24 md:py-32"
    >
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="font-mono text-xs uppercase tracking-[0.25em] text-orange-600 mb-4">
              <span>{`{ `}</span>portafolio<span>{` }`}</span>
            </div>
            <h2 className="font-display font-extrabold text-4xl md:text-5xl lg:text-6xl tracking-tight text-slate-900 max-w-3xl">
              Casos reales, resultados <span className="text-purple-700">medibles</span>.
            </h2>
          </div>
          <p className="max-w-md text-slate-600 text-base md:text-lg">
            Una selección de proyectos entregados en los últimos años, con impacto en negocio
            y métricas verificables.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {PORTFOLIO.map((p, idx) => (
            <button
              key={p.slug || p.title}
              type="button"
              onClick={() => openCase(p)}
              data-testid={`portfolio-card-${p.slug || idx}`}
              aria-label={`Ver caso: ${p.title}`}
              className={`group relative overflow-hidden rounded-2xl bg-slate-900 border border-slate-200 text-left focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-4 focus:ring-offset-slate-50 ${idx % 3 === 0 ? "md:col-span-2" : ""}`}
            >
              <div className="relative h-72 md:h-96 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.title}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/70 to-transparent" />
              </div>

              <div className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end">
                <span className="font-mono text-xs uppercase tracking-[0.2em] text-orange-400 mb-3">
                  {p.tag}
                </span>
                <h3 className="font-display font-extrabold text-2xl md:text-3xl text-white tracking-tight">
                  {p.title}
                </h3>
                <p className="mt-2 text-slate-200 max-w-xl">{p.description}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {p.metrics.map((m) => (
                    <span
                      key={m}
                      className="text-xs font-mono text-white bg-white/10 border border-white/15 rounded-full px-3 py-1"
                    >
                      {m}
                    </span>
                  ))}
                </div>
                <div className="mt-6 inline-flex items-center text-orange-400 font-medium text-sm group-hover:text-orange-300 transition-colors">
                  Ver caso <ArrowUpRight className="ml-1 h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      <CaseStudyDialog
        caseData={selected}
        open={!!selected}
        onOpenChange={(v) => { if (!v) setSelected(null); }}
      />
    </section>
  );
};

export default Portfolio;
